import type { PlaylistListRowModel } from './buildPlaylistListModel';
import { PlaylistListRow } from './PlaylistListRow';

type PlaylistListProps = {
  rows: PlaylistListRowModel[];
  onOpen: (playlistId: string) => void;
};

export function PlaylistList({ rows, onOpen }: PlaylistListProps) {
  return (
    <div
      className="overflow-hidden rounded-[14px] border"
      style={{
        background: 'var(--gs-panel)',
        borderColor: 'var(--gs-line)',
        animation: 'gs-in 260ms ease both',
      }}
    >
      {rows.map((row) => (
        <PlaylistListRow key={row.playlist.id} row={row} onOpen={onOpen} />
      ))}
    </div>
  );
}
